// extracted by mini-css-extract-plugin
export default {"Input":"AuthForm_Input__-mgy0","btn":"AuthForm_btn__VhdJ2","dropdown-basic-button":"AuthForm_dropdown-basic-button__vUKoE","BG":"AuthForm_BG__+lkxz"};